export const HOST_URL =
  process.env.REACT_APP_API_HOST || "http://localhost:4000";
export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY;
